module.exports = __webpack_public_path__ + "static/media/career-tree.28baf36b.png";